angular.module('core')
    .component('auditDataInfo', {
        bindings: {
            item: '<',
            objectId: '<?',
            objectType: '<?',
        },
        templateUrl: "app/utils/audit-data-info/audit-data-info.html",
        controller: function (modals, $location) {
            this.auditLogResourcesAllowed = ['TASK', 'SERVICE-REQUEST', 'CLIENT'];
            this.resourceLinkAllowed = ['TASK', 'NOTE', 'TODO', 'LEAD', 'INVOICE', 'PROPERTY', 'PROPERTY-DEAL', 'SERVICE-REQUEST', 'RENTAL-AGREEMENT', 'RENTAL-RESOURCE', 'WORKFLOW']

            this.$onChanges = () => {
                this.objectId = this.objectId || this.item?.id || null;
                this.objectType = this.objectType || this.item?.objectType || null;

                this.showAuditLog = this.item ? (this.auditLogResourcesAllowed.indexOf(this.objectType) > -1) : false;

                if (this.resourceLinkAllowed.includes(this.objectType)) {
                    this.resourceLink = `${$location.absUrl().split('#')[0]}#/${this.objectType.toLowerCase()}/${this.objectId}`;
                }
            }
            this.openAuditLog = (objectType, id) => {
                let auditLogModel = {
                    resourceType: objectType,
                    resourceId: id
                };
                return modals.open('app/utils/audit-data-info/audit-history-log-modal.html', 'AuditHistoryLogsDialogController', auditLogModel, {size: 'lg'}, "$ctrl")
            }
        }
    })
